export const DEFAULT_API_SAVE_USER_ENDPOINT = '/users/:userName';
export const DEFAULT_API_USER_INFO_ENDPOINT = '/actions/:userName/login';
export const DEFAULT_API_USER_CONNECTIONS_ENDPOINT = '/billing/user';
export const DEFAULT_API_KEYS_ENDPOINT = '/apiKeys';
export const DEFAULT_API_KEY_DELETE_ENDPOINT = '/apiKey/:keyId';
export const DEFAULT_API_KEY_CREATE_ENDPOINT = '/apiKey';
export const DEFAULT_API_UPDATE_OWN_USER_ENDPOINT = '/user';
export const DEFAULT_API_CURRENT_USER_ENDPOINT = '/user/me';
